<template>
	<div class="home">
		<TopBar msg="Welcome" />
	</div>
</template>
<script lang="ts" setup>
import TopBar from '@/components/TopBarMenu.vue';

// import $ from 'jquery'

// let data = $('#app');
// console.log(data);


</script>
<style lang="scss">
img {
	height: 30px;
}

.home {
	text-align: center;
}
</style>